import angular from 'angular';
import lendingExistingProductComparisons from './lendingExistingProductComparisons';

export default angular.module('lendingChooseProducts.scenes', [
  lendingExistingProductComparisons,
]).name;
